import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { SNAgenda } from './snagenda';
import { SNAgendaAppointment } from './snagendaappointment';
import { SNItem } from './snitem';

@RegisterItem()
export class SNAgendaDay extends SNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNAgendaDay';
    }

    get appointments(): SNAgendaAppointment[] {
        return this.childs$('SNItem.SNAgendaAppointment') as SNAgendaAppointment[];
    }

    public clone(): any {
        return new SNAgendaDay();
    }
}
